
<jsonforms-outlet
  [uischema]="detailUiSchema"
  [schema]="scopedSchema"
  [path]="propsPath">
</jsonforms-outlet>
